import { render } from "./Captacao.vue?vue&type=template&id=604121fd"
import script from "./Captacao.vue?vue&type=script&lang=js"
export * from "./Captacao.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__